module.exports = __webpack_public_path__ + "static/media/chs_2.08eaf536.png";